import type { PublicApiKey } from '#packages/apilib';
import type { createDeveloperModeApi } from './developerModeWrapper';

export const DeveloperModeApiKey: PublicApiKey<typeof createDeveloperModeApi> =
  {
    name: 'DeveloperModeApi',
    public: true,
  };
